// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"31a9d33e","513":"e445caf4","787":"4f5f3217"}[chunkId] + ".chunk.js";
};